// extracted by mini-css-extract-plugin
export default {"deviceButton":"EMDRButton_deviceButton__Kpaee","icon":"EMDRButton_icon__bPjH8"};